import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "onClick", "size", "color"];
import React from 'react';
import Proptypes from 'prop-types';
import Button from '../atoms/Button';
import FontIcon from '../atoms/FontIcon';
var ActionButton = function ActionButton(_ref) {
  var icon = _ref.icon,
    onClick = _ref.onClick,
    size = _ref.size,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    view: "icon"
  }, rest, {
    id: "icon-button"
  }), /*#__PURE__*/React.createElement(FontIcon, {
    onClick: onClick,
    color: color,
    size: size
  }, icon));
};
ActionButton.propTypes = {
  icon: Proptypes.string,
  onClick: Proptypes.func,
  size: Proptypes.number,
  color: Proptypes.string
};
ActionButton.defaultProps = {
  icon: 'icon-exclamation',
  onClick: function onClick() {},
  size: 'MD',
  color: 'white'
};
export default ActionButton;